import React from "react"
import classNames from "classnames";

import styles from "./styles.module.scss";

const ListItem = ({children, className}) => (
  <div className={classNames(styles.item, className || styles.itemDefault, "item")}>
    {children}
  </div>
);

const ListHeader = ({children, className}) => (
  <div className={classNames(styles.header, className || styles.headerDefault, "header")}>
    {children}
  </div>
);

const ListContent = ({children, className}) => (
  <div className={classNames(styles.content, className || styles.contentDefault, "content")}>
    {children}
  </div>
);

const ListDescription = ({children, className}) => {
  return <div className={classNames(styles.description, className || styles.descriptionDefault, "description")}>
    {children}
  </div>;
};

class List extends React.Component {
  static Content = ListContent;
  static Description = ListDescription;
  static Header = ListHeader;
  static Item = ListItem;

  render() {
    return <div className={classNames(styles.list, this.props.className || styles.listDefault, "list")}>
      {
        this.props.children
      }
    </div>;
  }
}

export default List;
